import http from "@/utils/http";
import * as urls from "@/recourses/urls/common";

export const sendWaitingList = async (data: any) => {
  const response = await http.post(urls.waitingList, data);
  return response.data;
};
